import { render, staticRenderFns } from "./GenericPrivacy.vue?vue&type=template&id=03610f38&scoped=true"
import script from "./GenericPrivacy.vue?vue&type=script&lang=js"
export * from "./GenericPrivacy.vue?vue&type=script&lang=js"
import style0 from "./GenericPrivacy.vue?vue&type=style&index=0&id=03610f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03610f38",
  null
  
)

export default component.exports